import service from '@/plugins/request'

//获取游戏类型
export const getGameType = (params) => {
    return service({
        url: 'app/game/getGameType',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

//获取盒子游戏
export const getGame = (params) => {
    return service({
        url: 'app/game/getGame',
        method: 'get',
        params,
        hideErrMsg: true
    })
}